import React from "react";

export const exportPlayerProfileStrengthAndAgilityDetails = (
  strengthAndAgilityData,
  lengthUnits,
  getHandDimensionsUnitValue,
  getHandDimensionsUnitLabelType,
  selectedEvent
) => {
  const styleHeaderCss = {
    fill: {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "e6eefb" },
    },
    font: { sz: "11", bold: true, color: { argb: "1d428a" } },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    },
    alignment: {
      wrapText: true,
      horizontal: "center",
      vertical: "top",
    },
  };

  const getThreeFourRunPositionData = () => {
    const threeFourRunPositionData = [
      { value: "Laser Time" },
      ...[...Array(4)].map(() => ({ value: "--" })),
    ];

    if (
      strengthAndAgilityData.threeFourRunLaserTimeData &&
      strengthAndAgilityData.threeFourRunLaserTimeData.length
    ) {
      threeFourRunPositionData.forEach((elem, i) => {
        strengthAndAgilityData.threeFourRunLaserTimeData.forEach((record) => {
          threeFourRunPositionData[record.positionId - 1].value =
            record.laserTime ? record.laserTime : "--";
        });
      });
    }

    return [
      {
        commonPosition: threeFourRunPositionData[0].value,
        firstPos: threeFourRunPositionData[1].value,
        secondPos: threeFourRunPositionData[2].value,
        thirdPos: threeFourRunPositionData[3].value,
        fourthPos: threeFourRunPositionData[4].value,
      },
    ];
  };

  const getProLanePositionData = () => {
    const proLanePositionData = [...Array(8)].map(() => ({ value: "--" }));

    if (
      strengthAndAgilityData.proLaneLaserTimeData &&
      strengthAndAgilityData.proLaneLaserTimeData.length
    ) {
      proLanePositionData.forEach((elem, i) => {
        strengthAndAgilityData.proLaneLaserTimeData.forEach((record) => {
          proLanePositionData[record.positionId - 1].value = record.laserTime
            ? record.laserTime
            : "--";
        });
      });
    }

    proLanePositionData.unshift({
      value: "Laser Time",
    });

    return [
      {
        commonPosition: proLanePositionData[0].value,
        firstPos: proLanePositionData[1].value,
        secondPos: proLanePositionData[2].value,
        thirdPos: proLanePositionData[3].value,
        fourthPos: proLanePositionData[4].value,
        fifthPos: proLanePositionData[5].value,
        sixthPos: proLanePositionData[6].value,
        seventhPos: proLanePositionData[7].value,
        eighthPos: proLanePositionData[8].value,
      },
    ];
  };

  const sASShuttleRunData = {
    title: "Strength & Agility Summary",
    headerNames: [
      {
        title: "Shuttle Run Left Trial Time (s)",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "Shuttle Run Left Laser Time (s)",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "Shuttle Run Right Trial Time (s)",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "Shuttle Run Right Laser Time (s)",
        width: 20,
        style: styleHeaderCss,
      },
    ],
    data:
      Object.keys(strengthAndAgilityData).length === 0
        ? []
        : [
            {
              shuttleRunLeftTrialTime:
                strengthAndAgilityData.shuttleRunLeftTrialTime !== null &&
                strengthAndAgilityData.shuttleRunLeftTrialTime !== ""
                  ? strengthAndAgilityData.shuttleRunLeftTrialTime
                  : "--",
              shuttleRunLeftLaserTime:
                strengthAndAgilityData.shuttleRunLeftLaserTime !== null &&
                strengthAndAgilityData.shuttleRunLeftLaserTime !== ""
                  ? strengthAndAgilityData.shuttleRunLeftLaserTime
                  : "--",
              shuttleRunRightTrialTime:
                strengthAndAgilityData.shuttleRunRightTrialTime !== null &&
                strengthAndAgilityData.shuttleRunRightTrialTime !== ""
                  ? strengthAndAgilityData.shuttleRunRightTrialTime
                  : "--",
              shuttleRunRightLaserTime:
                strengthAndAgilityData.shuttleRunRightLaserTime !== null &&
                strengthAndAgilityData.shuttleRunRightLaserTime !== ""
                  ? strengthAndAgilityData.shuttleRunRightLaserTime
                  : "--",
            },
          ],
    columnStyles: Array(4).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const sAsVerticalData = {
    title: "",
    headerNames: [
      {
        title: "Max Vertical (in)",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "Standing Vertical (in)",
        width: 20,
        style: styleHeaderCss,
      },
    ],
    data:
      Object.keys(strengthAndAgilityData).length === 0
        ? []
        : [
            {
              maxVerticalLeap:
                strengthAndAgilityData.maxVerticalLeap !== null &&
                strengthAndAgilityData.maxVerticalLeap !== ""
                  ? `${getHandDimensionsUnitValue(
                      strengthAndAgilityData.maxVerticalLeap
                    )}`
                  : "--",
              standingVerticalLeap:
                strengthAndAgilityData.standingVerticalLeap !== null &&
                strengthAndAgilityData.standingVerticalLeap !== ""
                  ? `${getHandDimensionsUnitValue(
                      strengthAndAgilityData.standingVerticalLeap
                    )}`
                  : "--",
            },
          ],
    columnStyles: Array(2).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const sASProLaneData = {
    title: "",
    headerNames: [
      {
        title: "Pro Lane Trial Time (s)",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "Pro Lane Total Laser Time (s)",
        width: 20,
        style: styleHeaderCss,
      },
    ],
    data:
      Object.keys(strengthAndAgilityData).length === 0
        ? []
        : [
            {
              proLaneTrialTime:
                strengthAndAgilityData.proLaneTrialTime !== null &&
                strengthAndAgilityData.proLaneTrialTime !== ""
                  ? strengthAndAgilityData.proLaneTrialTime
                  : "--",
              proLaneTotalLaserTime:
                strengthAndAgilityData.proLaneTotalLaserTime !== null &&
                strengthAndAgilityData.proLaneTotalLaserTime !== ""
                  ? strengthAndAgilityData.proLaneTotalLaserTime
                  : "--",
            },
          ],
    columnStyles: Array(2).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const sASPostionDrills = {
    title: "",
    headerNames: [
      {
        title: "Position",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "1",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "2",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "3",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "4",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "5",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "6",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "7",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "8",
        width: 20,
        style: styleHeaderCss,
      },
    ],
    data:
      getProLanePositionData().length > 0
        ? getProLanePositionData().map((record) => ({
            commonPosition: record.commonPosition
              ? record.commonPosition.toString()
              : "--",
            firstPos: record.firstPos ? record.firstPos.toString() : "--",
            secondPos: record.secondPos ? record.secondPos.toString() : "--",
            thirdPos: record.thirdPos ? record.thirdPos.toString() : "--",
            fourthPos: record.fourthPos ? record.fourthPos.toString() : "--",
            fifthPos: record.fifthPos ? record.fifthPos.toString() : "--",
            sixthPos: record.sixthPos ? record.sixthPos.toString() : "--",
            seventhPos: record.seventhPos ? record.seventhPos.toString() : "--",
            eighthPos: record.eighthPos ? record.eighthPos.toString() : "--",
          }))
        : [],
    columnStyles: Array(9).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const threeFourSprintData = {
    title: "",
    headerNames: [
      {
        title: "3/4 Court Sprint Time (s)",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "3/4 Court Sprint Total Laser Time (s)",
        width: 20,
        style: styleHeaderCss,
      },
    ],
    data:
      Object.keys(strengthAndAgilityData).length === 0
        ? []
        : [
            {
              threeFourRunTime:
                strengthAndAgilityData.threeFourRunTime !== null &&
                strengthAndAgilityData.threeFourRunTime !== ""
                  ? strengthAndAgilityData.threeFourRunTime
                  : "--",
              threeFourRunTotalLaserTime:
                strengthAndAgilityData.threeFourRunTotalLaserTime !== null &&
                strengthAndAgilityData.threeFourRunTotalLaserTime !== ""
                  ? strengthAndAgilityData.threeFourRunTotalLaserTime
                  : "--",
            },
          ],
    columnStyles: Array(2).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const threeFourpostionData = {
    title: "",
    headerNames: [
      {
        title: "Position",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "1",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "2",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "3",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "4",
        width: 20,
        style: styleHeaderCss,
      },
    ],
    data:
      getThreeFourRunPositionData().length > 0
        ? getThreeFourRunPositionData().map((record) => ({
            commonPosition: record.commonPosition
              ? record.commonPosition.toString()
              : "--",
            firstPos: record.firstPos ? record.firstPos.toString() : "--",
            secondPos: record.secondPos ? record.secondPos.toString() : "--",
            thirdPos: record.thirdPos ? record.thirdPos.toString() : "--",
            fourthPos: record.fourthPos ? record.fourthPos.toString() : "--",
          }))
        : [],
    columnStyles: Array(5).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };
  return [
    sASShuttleRunData,
    sAsVerticalData,
    sASProLaneData,
    sASPostionDrills,
    threeFourSprintData,
    threeFourpostionData,
  ];
};
